export function removeUnUsedSpace(inputString: string, isKeepLinebreak?: boolean): string {
  if (isKeepLinebreak !== undefined && isKeepLinebreak === true) {
    return (inputString || '')
      .replace(/[ \t]+/g, ' ')
      .replace(/\n+/g, '\n')
      .trim();
  } else {
    return (inputString || '').replace(/\s+/g, ' ').trim();
  }
}

export function isNullOrEmptyString(inputString?: string): boolean {
  return !inputString || inputString.trim().length === 0;
}

export function extractContent(html: string): string {
  const span = document.createElement('span');
  span.innerHTML = html;
  return span.textContent || span.innerText;
}
